export default "__VITE_PUBLIC_ASSET__83b8a083__"